import type { Store } from 'store/types/types';

export const getAllFarms = (state: Store) => state.farms;
export const getFarmById = (state: Store, id: string) => state.farms[id];
